import { gql, useQuery } from "@apollo/client";
import { Button, Image, Layout, PageHeader, Table } from "antd";
import { useApplicationContext } from "components/Application";
import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router";

const articleItemQuery = gql`
  query($id: ID!) {
    articleItem(id: $id) {
      id
      images {
        id
        image
        position
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();
  const navigate = useNavigate();
  const { id } = useParams();

  const variables = { id };
  const { loading, data } = useQuery(articleItemQuery, { variables, fetchPolicy: "cache-and-network" });

  const handleTableChange = () => {};

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (value: string) => <Image src={`${appEndpointStore}${value}`} width={50} />,
    },
    {
      title: "Position",
      dataIndex: "position",
    },
  ];

  return (
    <Fragment>
      <PageHeader
        ghost={true}
        title="Images"
        extra={
          <Button type="primary" onClick={() => navigate("edit")}>
            Edit
          </Button>
        }
      />
      <Layout.Content className="content">
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={data?.articleItem?.images}
          pagination={false}
          onChange={handleTableChange}
        />
      </Layout.Content>
    </Fragment>
  );
};
